import { IonContent, isPlatform } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { InfoProtection } from '@/components/InfoProtection';
import { useAccount } from '@/hooks/useAccount';
import { useCreateStripeClient } from '@/hooks/useCreateStripeClient';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { checkIsValidateEmail } from '@/pages/Onboarding/utils/checkIsValidEmail';
import { userService } from '@/services/user';
import { trackOnboardingComplete } from '@/utils/analytics.ts';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { EmailStyles } from './Email.styles';

export const ScreenEmail: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Email',
      });
    }
  }, []);

  const { refreshUser } = useAccount();

  const { createStripeClient, isCreatingStripeClient } =
    useCreateStripeClient();

  const form = useFormContext<LayoutDataType>();

  const inputRef = React.useRef<HTMLIonInputElement>(null);

  const formEmail = form.watch('email');

  const isValidEmail = checkIsValidateEmail(formEmail);

  React.useEffect(() => {
    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      });
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = async (): Promise<void> => {
    if (!formEmail || !isValidEmail) return;

    try {
      const lowerCaseEmail = formEmail.toLowerCase().trim();

      trackOnboardingComplete({ email: lowerCaseEmail });

      await Promise.all([
        createStripeClient(lowerCaseEmail),
        userService.createOrUpdate({
          onboarding_data: {
            onboarded: true,
          },
        }),
      ]);

      refreshUser();
    } catch (error) {
      console.error('Can not create a stripe user', error);
    }
  };
  return (
    <EmailStyles>
      <OnboardingNavigation isRenderBackButton={true} />

      <IonContent>
        <OnboardingTitle className="onboarding-email-title">
          She’s almost yours... you’ll see
          <br />
          her in a second
        </OnboardingTitle>

        <div className="email-images">
          <img
            src="/assets/layout-own-ai-trans/email/circle.svg"
            alt="circle"
            className="email-circle"
          />
          <img
            src="/assets/layout-own-ai-trans/email/lady.svg"
            alt="lady"
            className="email-lady"
          />
        </div>

        <OnboardingTitle className="email-title">
          Drop your email so we can create
          <br />
          your private match profile 🔥
        </OnboardingTitle>

        <div className="email-input-container">
          <FormInput
            form={form}
            hidden={false}
            onSubmit={handleNextStep}
            disableButton={!isValidEmail || isCreatingStripeClient}
            ref={inputRef}
            name="email"
            type="email"
            placeholder="Type your email"
            theme="primary"
          />
        </div>
        <div className="email-protection">
          <InfoProtection />
        </div>
      </IonContent>
    </EmailStyles>
  );
};
